export const getPlatform = () => {
  if(process.env.REACT_APP_PLATFORM != undefined){
    return process.env.REACT_APP_PLATFORM
  } else {
    const url = `${window.location.href}`
    if(url.includes("medicao")){
      return '1'
    } else if(url.includes("operacao") || url.includes("conexao")){
      return '0'
    } else if(url.includes("ecopiggy")){
      return '2'
    } else if(url.includes("whatsapp")){
      return '4'
    }
  }
}